/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPercentage80 = createReactComponent("outline", "percentage-80", "IconPercentage80", [["path", { "d": "M12 3a9 9 0 1 1 -8.497 6.025l8.497 2.975z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

export { IconPercentage80 as default };
//# sourceMappingURL=IconPercentage80.mjs.map
